<template>
  <div class="main">
       <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="车款对比"  />
        <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="selectCars"  type="primary" :disabled="searchResult.length==0"  class="actionBtn"  round >{{buttonLabel}} <svg-icon name="play" size="12" ></svg-icon> </el-button> 
        </div>
      <xy-toolbox-menu class="r">
        <!--  <xy-toolbox-menu-item custom><div class="custom-content"></div></xy-toolbox-menu-item><xy-toolbox-menu-item divided/>-->
        <xy-toolbox-menu-item icon="car_search" @click="chooseCars"  v-show="viewResult">返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel" v-show="viewResult">Excel导出  </xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
    </SearchBar>
    <div v-if="viewResult" style="margin-top:20px;">
    </div>
    <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" width="90%" :before-close="hideDialog" :center="false" :show-close="false" :append-to-body="true">
      <span class="dialog-title clearfix" slot="title">
                    <span>PK</span>
      </span>
      <div class="pkhead">
        <el-button class="vs-icon" @click="handleSwap()" size="medium">
          <svg-icon name="swap" size="20"></svg-icon>
        </el-button>
        <div class="pktitle">本品</div>
        <div class="pktitle">竞品</div>
      </div>
      <div class="vsbox">
        <svg-icon name="pk" size="40" class="vs-icon"></svg-icon>
        <div class="block">
          <draggable v-model="self" element="ul" class="car-list" :options="dragOptions">
            <li v-for="(item,index) of self" :key="index" class="left">
              <el-link icon="el-icon-delete" class="left-remove" @click="removeCar(1,index)"></el-link>
              <el-link icon="el-icon-document-add" class="left-copy" @click="copyCar(1,index)"></el-link> <span class="text"> {{item.name}} | {{item.msrp}}</span>
              <el-button size="small" icon="el-icon-arrow-right" circle @click="handleSwap(1,index)"> </el-button>
            </li>
          </draggable>
        </div>
        <div class="block">
          <draggable v-model="competingCars" element="ul" class="car-list" :options="dragOptions">
            <li v-for="(item,index) of competingCars" :key="index" class="right">
              <el-button size="small" icon="el-icon-arrow-left" circle @click="handleSwap(2,index)"> </el-button> <span class="text"> {{item.name}}  | {{item.msrp}} </span>
              <el-link icon="el-icon-delete" class="right-remove" @click="removeCar(2,index)"></el-link>
            </li>
          </draggable>
        </div>
      </div>
      <span slot="footer">
                       <el-button @click="hideDialog">返回</el-button>  

                           <el-button type="primary" :disabled="isDisabled(0)" @click="handleCommand(1)"> 装备 1V1 </el-button>
                              <el-button type="primary" :disabled="isDisabled(2)"  @click="handleCommand(3)"> 竞争力分析 </el-button>
                       <!-- <el-dropdown   type="primary" @click="handleClick" style="margin-left:10px;"  @command="handleCommand"   >
                            <el-button type="primary" :disabled="isDisabled(0)"> 选择对比方式 <i class="el-icon-arrow-down el-icon--right"></i></el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item  v-for="(item,index) of pktypes"  :command="item.id" :key="index"   :disabled ="isDisabled(item.id)"> {{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                      </el-dropdown> -->
                    </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapMutations,
    mapGetters,
    mapActions
  } from 'vuex';
  import SearchBar from '@/components/common/NewSearchBar.vue';
  import draggable from 'vuedraggable'
  export default {
    name: 'EquipCompare',
    components: {
      SearchBar,
      draggable
    },
    data() {
      return {
        tableCfg: null,
        viewResult: false,
        buttonLabel: "车款对比",
        currentModuleName: 'EquipCompare',
        showDialog: false,
        pk_type: 1,
        pktypes: [{
          id: 1,
          name: "装备 1v1"
        },  {
          id: 3,
          name: "竞争力分析"
        } ],
        carlist: [],
        self: [],
        competingCars: []
      }
    },
    methods: {
      ...mapMutations('commonsearch', ['setPivotTableKey', 'clearSearch']),
      ...mapActions('commonsearch', ['savePivotTableAsync']),
      selectCars() {
        let compareCars = this.displayResult;
        //     alert(JSON.stringify(compareCars));
        console.log(compareCars);
        if (compareCars.length < 2) {
          this.$message({
            message: '至少选项2个车型/车款',
            duration: 2000,
          });
          return;
        }
        var models = compareCars.filter((item, index) => {
          return compareCars.findIndex((obj) => {
            return obj.modeId === item.modeId;
          }) === index;
        });
        if (models.length > 2) {
          this.$message({
            message: '最多选择二个子车型',
            duration: 2000,
          });
          return;
        }
        this.self = [];
        this.competingCars = [];
        if (models.length == 1) {
          for (var i = 0; i < compareCars.length; i++) {
            let car = compareCars[i];
            let name = this.showSelectionSubmodel ? car.name : car.model;
            this.self.push({
              id: i,
              modeId: car.modeId,
              carId: car.id,
              name: name,
              msrp: car.msrp
            });
          }
        } else if (models.length == 2) {
          const first = compareCars[0].modeId
          for (var i = 0; i < compareCars.length; i++) {
            let car = compareCars[i];
            let name = this.showSelectionSubmodel ? car.name : car.model;
            if (first == car.modeId) {
              this.self.push({
                id: i,
                modeId: car.modeId,
                carId: car.id,
                name: name,
                msrp: car.msrp
              });
            }else{
        this.competingCars.push({
                id: i,
                modeId: car.modeId,
                carId: car.id,
                name: name,
                msrp: car.msrp
              });

            }
          }
        }
       
        this.openDialog();
      },
         chooseCars() {
      this.viewResult = false;
    },
      removeCar(t, index) {
        // this.carlist.splice(this.carlist.findIndex(v => v.id=== id),1);
        if (t == 1) {
          this.self.splice(index, 1);
        } else {
          this.competingCars.splice(index, 1);
        }
      },
      copyCar(t, index) {
        var car = JSON.parse(JSON.stringify(this.self[index]));
        car.index++;
        this.self.splice(index, 0, car);
        for (var i = index; i < this.self.length; i++) {
          this.self[i].id++;
        }
      },
      openDialog() {
        this.showDialog = true;
      },
      hideDialog() {
        this.showDialog = false;
      },
      handleClick(command) {
        this.pk_type = 1;
       // this.$message('click on item~~  ' + command);
      },
      handleCommand(command) {
        this.pk_type = command;
      //  this.$message('click on item ' + command);
        var selfId = this.self[0].carId;
        var compId = this.competingCars[0].carId;
        var params = [];
        if (this.pk_type == 1) {
          for (var i = 0; i < this.self.length; i++) {
            params.push([this.self[i], this.competingCars[i]]);
          }
          this.$router.push({
            name: 'equippk1',
            params: {
              'q': params
            }
          });
        } else if (this.pk_type == 3) {
          for (var i = 0; i < this.self.length; i++) {
            params.push([this.self[i], this.competingCars[i]]);
          }
          this.$router.push({
            name: 'equippk2',
            params: {
              'q': params
            }
          });
        } else if (this.pk_type == 4) {
          for (var i = 0; i < this.self.length; i++) {
            params.push(this.self[i]);
          }
          for (var i = 0; i < this.competingCars.length; i++) {
            params.push(this.competingCars[i]);
          }
          this.$router.push({
            name: 'equippk4',
            params: {
              'q': params
            }
          });
        }
      },
      handleSwap(t, index) {
        if (t) {
          if (t == 1) {
            let car = this.self[index];
            this.competingCars.push(car);
            this.self.splice(index, 1);
          } else if (t == 2) {
            let car = this.competingCars[index];
            this.self.push(car);
            this.competingCars.splice(index, 1);
          }
        } else {
          [this.self, this.competingCars] = [this.competingCars, this.self];
        }
      },
    },
    computed: {
      ...mapGetters('commonsearch', ['searchCategories', 'hasSelectionResult', 'hasSearchResult', 'showSelectionSubmodel', 'selectionResult', 'searchResult']),
      dragOptions() {
        return {
          animation: 0,
          group: "description",
        };
      },
      isDisabled() {
        return function(type) {
          if (type == 0) {
            return this.self.length == 0 || this.competingCars.length == 0;
          }
          if (type == 1 || type == 2) {
            if (!this.showSelectionSubmodel) {
              return true;
            }
            return !(this.self.length == this.competingCars.length);
          }
          return false;
        }
      },
      // 显示数据
      displayResult() {
        if (this.showSelectionSubmodel) {
          return this.selectionResult;
        } else {
          // 最小颗粒为子车型
          return this.selectionResult.filter((item, index) => {
            return this.selectionResult.findIndex((obj) => {
              return obj.model === item.model;
            }) === index;
          });
        }
      },
    },
    watch: {
      showSelectionSubmodel: function(newVal) {
        this.buttonLabel = newVal ? "对比车款" : "对比车款";
      }
    },
  }
</script>
  